export const tituloEspec1 = 'Relacionamento Familiar';
export const tituloEspec2 = 'Relacionamento Amoroso';
export const tituloEspec3 = 'Autoestima e Excesso de Autocrítica';
export const tituloEspec4 = 'Transtornos e Gerenciamento de Emoções';
export const tituloEspec5 = 'Ansiedade Emocional';
export const tituloEspec6 = 'Estresse, Depressão e Humor';
export const tituloEspec7 = 'Tratamento Comprovado';
export const tituloEspec8 = 'Bem-estar Integral';
export const tituloEspec9 = 'Facilidade e Flexibilidade';
export const tituloEspec10 = 'Apoio Contínuo';
export const tituloEspec11 = 'Acolhimento Profissional';
export const tituloEspec12 = 'Terapia Personalizada';